import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Button } from 'rmwc/Button';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { ArcherContainer, ArcherElement } from 'react-archer'
import ReactTooltip from 'react-tooltip'
import UserResourcePage from './UserResourcePage';
import UserRenderUnlistedCompetency from './UserRenderUnlistedCompetency';

class UserFlowChartPage extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
    		data:{
    			levelId: '',
    			trackId: '',
    			topicId: ''
    		},
            flowchart:{
                flowchartDetails: []
            },
            pageView: 'default',
            renderFlowchart: {
                nameOfCompetency: '',
                idOfCompetency: ''
            },
            manageData: {
                competencyDetails: []
            }
    	}
    }

    handleUnlistedCompetencyView = (competencyName, competencyId) => {
        let pageView = Object.assign({}, this.state.pageView)
        let renderFlowchart = Object.assign({}, this.state.renderFlowchart)
        renderFlowchart.nameOfCompetency = competencyName
        renderFlowchart.idOfCompetency = competencyId
        pageView = 'resource_view'
        this.setState({renderFlowchart: renderFlowchart, pageView: pageView})
      }

    insideCompetency = (e, competencyName, competencyId) => {
        e.preventDefault()
        let pageView = Object.assign({}, this.state.pageView)
        let renderFlowchart = Object.assign({}, this.state.renderFlowchart)
        renderFlowchart.nameOfCompetency = competencyName
        renderFlowchart.idOfCompetency = competencyId
        pageView = 'resource_view'
        this.setState({renderFlowchart: renderFlowchart, pageView: pageView})
    }

    handlePageReturn = (event) => {
        let pageView = Object.assign({}, this.state.pageView)
        pageView = "default"
        this.setState({pageView: pageView})
    }

    handleMainPageReturn = (e) => {
        this.props.handleBackAction(this.props.user.accessToken)
    }

    componentDidMount() {
        let flowchart = Object.assign({}, this.state.flowchart)
        let manageData = Object.assign({}, this.state.manageData)
        return api.userRenderCompetenciesAll(this.props.user.accessToken, this.props.roadmapId)
        .then((result) => {
            manageData.competencyDetails = result.data
            api.userFlowChartDisplay(this.props.user.accessToken, this.props.roadmapId)
            .then((result) => {
                flowchart.flowchartDetails = result.data
                this.setState({manageData: manageData, flowchart: flowchart})
            })
        })
    }

    render () {
        let insideCompetency = this.insideCompetency
        let flowchartComponent
        let viewComponent
        let competencyComponent

        if(this.state.manageData.competencyDetails.length>0){
            let handleUnlistedCompetencyView = this.handleUnlistedCompetencyView
            competencyComponent = (
                <Grid>
                    {this.state.manageData.competencyDetails.map(function(competency){
                        return(
                            <UserRenderUnlistedCompetency competencyName = {competency.name} 
                                competencyId = {competency.id} 
                                onhandleUnlistedCompetencyView = {handleUnlistedCompetencyView} />
                        )
                    })}
                </Grid>
            )
        }

        if(this.state.flowchart.flowchartDetails.length>0){
            let flowchart = this.state.flowchart
                flowchartComponent = (
                    <div>
                        <ArcherContainer strokeColor='blue'>
                            {this.state.flowchart.flowchartDetails.map(function(flowchartDetail){
                                let relationsTest=[{
                                    from: { anchor: 'bottom'},
                                    to: { anchor: 'top', id:flowchartDetail.child_id },
                                }]
                                let flowchartCompId = flowchartDetail.id
                                let flowchartCompName = flowchartDetail.name
                                    if(flowchartDetail.child_id === undefined){
                                        return (
                                        <div> <br /> <br />
                                            <ArcherElement id={flowchartDetail.id}>
                                                <div>
                                                    <Grid>
                                                        <GridCell span="4">
                                                        </GridCell>
                                                        <GridCell span="4">
                                                            <Card style={{padding: '25px'}} className='flowchart-element-color'>
                                                                <Typography use="headline7" align="center" color="#1483EE"> <a href="javascript:void(0)" onClick= {((e) => insideCompetency(e, flowchartCompName, flowchartCompId))} style={{cursor: 'pointer'}} data-tip={flowchartDetail.description}> {flowchartDetail.name} </a> </Typography>
                                                                <ReactTooltip place="right" type="dark" effect="solid"/>
                                                            </Card>
                                                        </GridCell>
                                                        <GridCell span="4">
                                                        </GridCell>
                                                    </Grid>
                                                </div>
                                            </ArcherElement> 
                                        </div>
                                        )
                                    }
                                    return (<div> <br /> <br />
                                        <ArcherElement id={flowchartDetail.id} relations={relationsTest}>
                                            <div>
                                                <Grid>
                                                    <GridCell span="4">
                                                    </GridCell>
                                                    <GridCell span="4">
                                                        <Card style={{padding: '25px'}} className='flowchart-element-color'>
                                                            <Typography use="headline7" align="center"> <a href="javascript:void(0)" onClick= {((e) => insideCompetency(e, flowchartCompName, flowchartCompId))} style={{cursor: 'pointer'}} data-tip={flowchartDetail.description}> {flowchartDetail.name} </a> </Typography>
                                                            <ReactTooltip place="right" type="dark" effect="solid"/>
                                                        </Card>
                                                    </GridCell>
                                                    <GridCell span="4">
                                                    </GridCell>
                                                </Grid>
                                            </div>
                                        </ArcherElement> </div>
                                    )
                            })} 
                        </ArcherContainer>
                    </div>
                )
        }
        if (this.state.pageView == 'default') {
            viewComponent = (
                <div>
                <GridCell span="2">
                    <Button raised style={{width: '10%'}} onClick={this.handleMainPageReturn}>Back</Button>
                </GridCell>
                <br />
                <GridCell span="12">
                    <Card style={{padding: '25px'}}>
                        <Typography use="headline5">{this.props.roadmapName} </Typography>
                    </Card>
                    <br />
                    <Typography use="subtitle1"> The roadmap for the  topic, <b>{this.props.topicName}</b> (Please hover over the Competency for further details)</Typography>
                    {flowchartComponent}
                </GridCell>
                </div>
            )
        }
        else if(this.state.pageView == 'resource_view') {
            viewComponent = (
                <GridCell span="12">
                <UserResourcePage competencyId = {this.state.renderFlowchart.idOfCompetency}
                    competencyName = {this.state.renderFlowchart.nameOfCompetency}
                    handleFlowChartPageReturn = {this.handlePageReturn} />
                </GridCell>
            )
        }
    	return (
    		<div>
                {viewComponent}
            </div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserFlowChartPage);



// WEBPACK FOOTER //
// ./src/views/roadmap/UserFlowChartPage.jsx